module.exports = __webpack_public_path__ + "k.no1.02c3c1d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/k.no1.jpg
// module id = FNvc
// module chunks = 0